import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["Container"];
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import Measure from 'react-measure';
var StyledHiddenItems = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\theight: 0;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tposition: absolute;\n"])));
export var CalculateMaxItems = /*#__PURE__*/function (_React$Component) {
  function CalculateMaxItems() {
    var _this;
    _classCallCheck(this, CalculateMaxItems);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CalculateMaxItems, [].concat(args));
    _defineProperty(_this, "state", {
      containerDimensions: {
        width: 0
      },
      itemsDimensions: {
        width: 0
      }
    });
    _defineProperty(_this, "updateContainerDimensions", function (rect) {
      _this.setState({
        containerDimensions: rect.bounds
      });
    });
    _defineProperty(_this, "updateItemsDimensions", function (rect) {
      _this.setState({
        itemsDimensions: rect.bounds
      });
    });
    return _this;
  }
  _inherits(CalculateMaxItems, _React$Component);
  return _createClass(CalculateMaxItems, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        Container = _this$props.Container,
        props = _objectWithoutProperties(_this$props, _excluded);
      var _this$state = this.state,
        maxItems = _this$state.maxItems,
        maxVisibleItems = _this$state.maxVisibleItems;
      if (!maxItems) {
        return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: this.updateContainerDimensions
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return /*#__PURE__*/React.createElement("div", {
          ref: measureRef
        }, !!maxVisibleItems && /*#__PURE__*/React.createElement(Container, _extends({}, props, {
          maxItems: maxVisibleItems
        })));
      }), /*#__PURE__*/React.createElement(StyledHiddenItems, null, /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: this.updateItemsDimensions
      }, function (_ref2) {
        var measureRef = _ref2.measureRef;
        return /*#__PURE__*/React.createElement("div", {
          ref: measureRef
        }, /*#__PURE__*/React.createElement(Container, _extends({}, props, {
          maxItems: maxItems,
          hidden: true
        })));
      })));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMaxItems(this.props);
    }
  }, {
    key: "setMaxItems",
    value: function setMaxItems(props) {
      if (props.maxItems > 0) {
        var maxItems = Math.min(props.itemCount, props.maxItems);
        this.setState({
          maxItems: maxItems
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.maxItems !== this.props.maxItems || prevProps.itemCount !== this.props.itemCount) {
        this.setMaxItems(this.props);
        return;
      }
      if (this.state.itemsDimensions.width === 0 || this.state.containerDimensions.width === 0 || this.state.itemsDimensions === prevState.itemsDimensions && this.state.containerDimensions === prevState.containerDimensions) {
        return;
      }
      if (this.state.itemsDimensions.width <= this.state.containerDimensions.width && this.state.maxItems < this.props.maxItems && this.state.maxItems < this.props.itemCount && this.state.containerDimensions.width > prevState.containerDimensions.width) {
        this.setState(function (state) {
          return {
            maxItems: state.maxItems + 1
          };
        });
      } else if (this.state.itemsDimensions.width > this.state.containerDimensions.width && this.state.maxItems > 1 && (this.state.containerDimensions.width <= prevState.containerDimensions.width || prevState.containerDimensions.width === 0)) {
        this.setState(function (state) {
          return {
            maxItems: state.maxItems - 1
          };
        });
      } else if (this.state.maxVisibleItems !== this.state.maxItems) {
        this.setState(function (state) {
          return {
            maxVisibleItems: state.maxItems
          };
        });
      }
    }
  }]);
}(React.Component);